import React, { useEffect } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import TableRow from '@material-ui/core/TableRow'
import { logTable } from 'assets/TableHeader'
import M_TableCell from 'components/1_Atoms/2_Molecules/M_TableCellHead'
import { organismLog } from 'utils/logUtil'
import { useUser } from 'hooks/useLogin'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
    },
  }),
)

const width = logTable.width
const label = logTable.label

const O_TableHeaderLog = () => {
  useEffect(() => organismLog('O_TableHeaderLog'))
  const classes = useStyles()
  const [isJapell] = useUser()

  return (
    <TableRow hover className={classes.root}>
      {/* 日付 */}
      <M_TableCell category="data" width={width.ADD_YMD} title={label.ADD_YMD} data={label.ADD_YMD} />
      {/* 時間 */}
      <M_TableCell category="data" width={width.ADD_HNS} title={label.ADD_HNS} data={label.ADD_HNS} />
      {/* 登録・削除 */}
      <M_TableCell category="data" width={width.TOROKU_KBN} title={label.TOROKU_KBN} data={label.TOROKU_KBN} />
      {/* 事業所CD */}
      {isJapell ? <M_TableCell category="data" width={width.JIGYO_CD} title={label.JIGYO_CD} data={label.JIGYO_CD} /> : <></>}
      {/* 事業所名 */}
      {isJapell ? <M_TableCell category="data" width={width.JIGYO_NM} title={label.JIGYO_NM} data={label.JIGYO_NM} /> : <></>}
      {/* 得意先CD */}
      <M_TableCell category="data" width={width.TOKUI_CD} title={label.TOKUI_CD} data={label.TOKUI_CD} />
      {/* 得意先名 */}
      <M_TableCell category="data" width={width.TOKUI_NM} title={label.TOKUI_NM} data={label.TOKUI_NM} />
      {/* 店舗CD */}
      <M_TableCell category="data" width={width.TEN_CD} title={label.TEN_CD} data={label.TEN_CD} />
      {/* 店舗名 */}
      <M_TableCell category="data" width={width.TEN_NM} title={label.TEN_NM} data={label.TEN_NM} />
      {/* メールアドレス */}
      <M_TableCell category="data" width={width.MAIL} title={label.MAIL} data={label.MAIL} />
      {/* 氏名 */}
      <M_TableCell category="data" width={width.NAME} title={label.NAME} data={label.NAME} />
      {/* 登録者メール */}
      <M_TableCell category="data" width={width.ADD_MAIL} title={label.ADD_MAIL} data={label.ADD_MAIL} />
      {/* 登録者名 */}
      <M_TableCell category="data" width={width.ADD_NAME} title={label.ADD_NAME} data={label.ADD_NAME} />
    </TableRow>
  )
}

export default React.memo(O_TableHeaderLog)
